import createDataContext from './createDataContext'

const irmAffiliationReducer = (state, action) => {
  switch (action.type) {
    case 'IRM_AFFILIATION:FETCH_STARTED':
      return { ...state, isLoading: true, failed: false }
    case 'IRM_AFFILIATION:FETCH_RECEIVED':
      return {
        ...state,
        isLoading: false,
        affiliations: action.payload.affiliations || [],
        total: action.payload.total || 0,
      }
    case 'IRM_AFFILIATION:SET_PAGE':
      return { ...state, page: action.payload.page }
    case 'IRM_AFFILIATION:SET_ROWS_PER_PAGE':
      return { ...state, page: action.payload.page, rowsPerPage: action.payload.rowsPerPage }
    case 'IRM_AFFILIATION:FAILED':
      // reset the state if it's a 400 error. because the user may have entered a custom person/organization
      // the error message notify the user that only system person/organization is supported here
      if (action.payload.response && action.payload.response.status === 400) {
        return { ...state, page: 0, failed: true, isLoading: false }
      } else {
        throw action.payload
      }
    default:
      throw new Error(`Unsupported action type: ${action.type}`)
  }
}

const initialState = {
  affiliations: [],
  total: 0,
  rowsPerPage: 25,
  page: 0,
  isLoading: false,
  failed: false,
}

export const { Provider, Context } = createDataContext(irmAffiliationReducer, initialState)
